// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportContent_root__25k-D","content":"ReportContent_content__Gx8mI","stepsContainer":"ReportContent_stepsContainer__6x9aV","title":"ReportContent_title__20p12"};